import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class SnNotification extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public notificationType: SnNotificationType;

  @Expose()
  public email: string;

  @Expose()
  public mobilePhone: string;

  @Expose()
  public organization: string;

  @Expose()
  public group: string;

  @Expose()
  public user: string;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}

export enum SnNotificationType {
  sms = 'SMS',
  email = 'Email',
  push = 'Push',
}
